import { combineReducers, configureStore } from '@reduxjs/toolkit';

import {
  appReducer,
  canvasReducer,
  jobReducer,
  rpcReducer,
} from './reducers';

const reducers = {
  app: appReducer,
  canvas: canvasReducer,
  job: jobReducer,
  rpc: rpcReducer,
};

const allReducers = { ...reducers };
const mainReducer = combineReducers(allReducers);
const middleware = [];

const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const devTools = process.env.NODE_ENV !== 'production' && reduxDevTools;

const handleMiddleware = getDefaultMiddleWare => {
  const options = { serializableCheck: false };
  return getDefaultMiddleWare(options).concat(middleware);
};

const storeConfig = {
  reducer: mainReducer,
  devTools,
  middleware: handleMiddleware,
};

const store = configureStore(storeConfig);

export { store };